<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex flex-column flex-md-row align-items-start justify-content-md-between">
        <div class="mb-0">
          <h1 class="page-title">Modèles de compte-rendu</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" class="text-nowrap">
          <plus-icon size="18" class="mr-1" /> Ajouter un modèle
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableSurgeryTemplate"
          identifier="B122TableSurgeryTemplate"
          init-b122-table-url="/surgeryTemplate/initB122Table"
          get-b122-table-results-url="/surgeryTemplate/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <surgery-template-delete-modal :selectedSurgeryTemplate="ui.selectedSurgeryTemplate" @didDeleteSurgeryTemplate="didDeleteSurgeryTemplate()"></surgery-template-delete-modal>

  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import SurgeryTemplateDeleteModal from "./SurgeryTemplateDeleteModal";

export default {

  name: 'SurgeryTemplateIndex',

  components: {
    B122Table,
    SurgeryTemplateDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Nom de la chirurgie",
          key: "name",
          sortable: true
        },
        {
          label: "Description",
          key: "description",
          sortable: true,
          formatter: function (value, key, item) {
            if (!value) {
              return ""
            }
            const maxNbOfChars = 200
            if (value.length > maxNbOfChars) {
              return `${value.substring(0, maxNbOfChars)}...`
            }
            return value
          }
        },
        {
          label: "",
          key: "actions"
        }
      ],

      ui: {
        selectedSurgeryTemplate: null
      }

    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'SurgeryTemplateCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'SurgeryTemplateShow',
        params: {
          surgeryTemplateId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'SurgeryTemplateEdit',
        params: {
          surgeryTemplateId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedSurgeryTemplate = row.item
      this.$bvModal.show('surgery-template-delete-modal')
    },

    didDeleteSurgeryTemplate() {
      this.ui.selectedSurgeryTemplate = null;
      this.$refs.B122TableSurgeryTemplate.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/surgeryTemplate/SurgeryTemplateIndex.vue